
export const zimConfig = {
    logoUrl: 'assets/images/zim-head.png',
    postlogo:'assets/images/zimpost-logo.png',
    language: 'en',
    currency: 'Z$',
    shortLogo:'assets/images/zimemblem.png',
    country:'Zimbabwe',
    favicon:'assets/cropped-ship2myid-icon-32x32.png',
    isPayment:false,
    isMsgCharge:false,
    loginPostlogo:'assets/images/ship2myidlogo_Sq.png',
    loginCountrylogo:'assets/images/zimpost-logo.png',
    timezone:'Africa/Harare',
    headerpostlogo:'assets/images/zim-head.png'
  };